import { TypeCategoriesIcons } from "../constants/document_categories";

/**
 * recupera se c'è il correctedValue, altrimenti il value in un array di metadati il cui paramentro name è uguale a nameParam
 * @param {*} metadataArray: l'array di metadata
 * @param {*} nameParam: il valore del parametro name
 */
export function getValueFromMetadata(metadataArray, nameParam) {
  let valueMeta = metadataArray.find((el) => el.name === nameParam);
  if (valueMeta) {
    valueMeta = valueMeta.correctedValue ? valueMeta.correctedValue : valueMeta.value;
  } else {
    valueMeta = "-";
  }
  return valueMeta;
}

export function getIconByType(typeDoc, types) {
  let objIcons = null;
  if (!types) {
    objIcons = TypeCategoriesIcons.find((el) => {
      return el.type === typeDoc;
    });
    objIcons = objIcons ? objIcons.icon : "file-alt";
  } else {
    let arrayTypes = Object.values(types)?.[0];
    if (!arrayTypes) {
      objIcons = "file-alt";
    } else {
      objIcons = Object.values(types)?.[0]?.find((el) => {
        return el.label === typeDoc;
      });
      objIcons = objIcons ? objIcons.classIcon : "file-alt";
    }
  }

  return objIcons;
}
